export const Forms = () => {
  document.addEventListener('readystatechange', () => {
    // Extra HTML for custom checkboxes  
    const checkboxes = document.querySelectorAll('.checkbox-wrap');

    if (checkboxes.length) {
      checkboxes.forEach(checkbox => {
        let span = document.createElement('span');
        span.classList.add('checkbox')
        checkbox.querySelector('.nf-field-element').append(span);
      });
    }
  });
}
